// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../../Config.bs.js";
import * as OrderDetailsMapRepo from "./OrderDetailsMapRepo.bs.js";
import * as DummyOrderDetailsMapRepo from "./DummyOrderDetailsMapRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return {
            fetchOrderMapData: DummyOrderDetailsMapRepo.OrderDetailsMapRepo.fetchOrderMapData
          };
  } else {
    return OrderDetailsMapRepo.OrderDetailsMapRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
